import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import * as _ from "../../../../constants/Constants";
import PreBoardingVendorProfile from "./PreBoardingVendorProfile";
import { useSelector } from "react-redux";
import { convertTimestampToDate } from "./helpers";
import VendorProfileHeader from "./VendorProfileHeader";

const VendorProfile = ({
  onboardingStatus,
  vendorProfileDetails,
  roleName,
  getUpdatedVendorData
}) => {
  const store = useSelector(({ service }) => ({
    vendorProfileTypeDetails: service.vendorProfile?.profileTypeDetails || [],
    vendorStatus: service.vendorStatus,
  }));
  const integrationStartDate = vendorProfileDetails.integrationStartDate;
  const [vendorProfileState, setVendorProfileState] = useState({
    intDate: "",
    holdDate: "",
  });

  useEffect(() => {
    setVendorProfileState((state) => ({
      ...state,
      intDate: convertTimestampToDate(
        vendorProfileDetails.integrationStartDate
      ),
    }));
  }, [vendorProfileDetails.integrationStartDate]);

  useEffect(() => {
    let newHoldDate = "";
    const holdStatus = store.vendorStatus.filter(
      (value) =>
        value.vendorStatus !== null &&
        value.vendorStatus?.statusId === 18 &&
        value.vendorStatus?.lastStatusUpdatedValue === "Approved"
    );

    if (Array.from(holdStatus).length > 0) {
      Array.from(holdStatus).forEach((value) => {
        newHoldDate = convertTimestampToDate(
          value.vendorStatus !== null
            ? value.vendorStatus?.lastStatusUpdatedDate
            : ""
        );
      });
    }
    setVendorProfileState((state) => ({
      ...state,
      holdDate: newHoldDate,
    }));
  }, [store.vendorStatus]);

  const vendorLiveStatus = useSelector(
    (state) => state.common.boardingStatuses[_.LIVE_ID]
  );
  const getVDFValue = () => {
    return vendorLiveStatus === _.APPROVED
      ? vendorProfileDetails.vendorConnectionPlatform
      : "";
  };
  return (
    <>
      <Row>
        <div className="col-md-12 mt-2">
          <VendorProfileHeader
            text={_.VENDOR_PROFILE}
            profileHeaderIntState={_.VP_INT_START_DATE_LABEL}
            profileHeaderHoldState={_.VP_HOLD_START_DATE_LABEL}
            profileHeaderVar={vendorProfileState}
          />
        </div>
      </Row>
      <Row>
        <Col md={12}>
          <PreBoardingVendorProfile
            onboardingStatus={onboardingStatus}
            integrationStartDate={integrationStartDate}
            getVDFValue={getVDFValue}
            vendorDetails={vendorProfileDetails}
            profileTypeDetails={store.vendorProfileTypeDetails}
            vendorStatus={store.vendorStatus}
            roleName={roleName}
            getUpdatedVendorData={getUpdatedVendorData}
          />
        </Col>
      </Row>
    </>
  );
};

export default VendorProfile;
